import * as React from "react";
import { Card, CardContent } from "../ui/card";
import { Label } from "../ui/label";
import { useFilteredAttendance } from "@/hooks/useFilteredAttendance";
import { ChevronDown, Download, Search } from "lucide-react";
import handleExport from "@/hooks/useExportAtt";
import AttHistoryCards from "./AttHistoryCards";

type AttendanceFilterProps = {
  setFilteredData: React.Dispatch<React.SetStateAction<any[]>>;
};

export default function AttendanceFilter({
  setFilteredData,
}: AttendanceFilterProps) {
  const [selectedMonth, setSelectedMonth] = React.useState<string>("");
  const [selectedYear, setSelectedYear] = React.useState<string>("");

  const {
    filteredData,
    totalDays,
    presentDays,
    absentDays,
    attendancePercentage,
    months,
  } = useFilteredAttendance(selectedMonth, selectedYear);

  const YEARS = Array.from(
    { length: new Date().getFullYear() - 2022 + 1 },
    (_, i) => (new Date().getFullYear() - i).toString(),
  );

  const handleDowanlod = () => {
    handleExport(
      filteredData,
      totalDays,
      presentDays,
      absentDays,
      attendancePercentage,
      selectedMonth,
      selectedYear,
    );
  };

  React.useEffect(() => {
    setFilteredData(filteredData);
  }, [filteredData]);

  return (
    <>
      <AttHistoryCards
        totalDays={totalDays}
        presentDays={presentDays}
        absentDays={absentDays}
        attendancePercentage={attendancePercentage}
      />

      <Card className="mb-6">
        <CardContent className="p-4">
          <div className="flex flex-col md:flex-row gap-4 sm:items-end">
            <div className="flex-1">
              <Label className="text-sm text-muted-foreground mb-1 block">
                Select Month
              </Label>
              <div className="relative">
                <select
                  className="w-full p-2 border rounded-lg appearance-none bg-muted pr-10"
                  value={selectedMonth}
                  onChange={(e) => setSelectedMonth(e.target.value)}
                >
                  <option value="">All Months</option>
                  {months.map((month) => (
                    <option key={month} value={month}>
                      {month}
                    </option>
                  ))}
                </select>
                <ChevronDown
                  className="absolute right-3 top-1/2 transform -translate-y-1/2 text-foreground"
                  size={16}
                />
              </div>
            </div>
            <div className="flex-1">
              <label className="text-sm text-muted-foreground mb-1 block">
                Select Year
              </label>
              <div className="relative">
                <select
                  className="w-full p-2 border rounded-lg appearance-none bg-muted pr-10"
                  value={selectedYear}
                  onChange={(e) => setSelectedYear(e.target.value)}
                >
                  <option value="">All Years</option>
                  {YEARS.map((year) => (
                    <option key={year} value={year}>
                      {year}
                    </option>
                  ))}
                </select>
                <ChevronDown
                  className="absolute right-3 top-1/2 transform -translate-y-1/2 text-foreground"
                  size={16}
                />
              </div>
            </div>
            <div className="flex items-end gap-2">
              <button className="bg-blue-500 text-white px-4 py-2 rounded-lg">
                <Search size={16} className="inline-block mr-2" />
                Search
              </button>
              <button
                onClick={handleDowanlod}
                className="bg-green-500 text-white px-4 py-2 rounded-lg"
              >
                <Download size={16} className="inline-block mr-2" />
                Download
              </button>
            </div>
          </div>
        </CardContent>
      </Card>
    </>
  );
}
